import {
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Pagination,
  Box,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../../../Apis";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import DialogFanpageList from "./DialogFanpageList";
import { useNavigate, useParams } from "react-router-dom";
import FanpageGroupForVector from "./FanpageGroupForVector";
import FanpageList from "./FanpageList";

const TrainingHistoryList = ({
  is_login,
  isLoading,
  setIsLoading,
  listFanpages,
  setIsUpdateFanpageInVectorLoading,
  list_group_fanpage,
  trainingHistotyList = [],
  setTrainingHistoryList,
  totalPage,
  currentPage,
  handlePageChange,
  // setTotalPage
}) => {
  const { ai_id } = useParams();
  const { t } = useTranslation();
  // const navigate = useNavigate();
  // const [trainingHistotyList, setTrainingHistoryList] = useState([]);
  // const [totalPage, setTotalPage] = useState(1);
  // const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [gptVectorId, setGptVectorId] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);

  const [fanpagesSelected, setFanpagesSelected] = useState([]);

  const handleDeleteHistory = (id) => {
    Swal.fire({
      title: "Bạn có chắc chắn muốn xóa lịch sử huấn luyện này?",
      text: "Hành động này không thể hoàn tác!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Xóa",
      cancelButtonText: "Hủy",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);
          const res = await fetch(
            `${api.gpt_assistant_training_delete}?vector_id=${id}`,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${is_login}`,
              },
            }
          );
          const data = await res.json();
          if (data?.success) {
            Swal.fire(
              "Đã xóa!",
              data?.message || "Lịch sử huấn luyện đã được xóa.",
              "success"
            );
            // Cập nhật lại danh sách sau khi xóa
            setTrainingHistoryList((prevList) =>
              prevList.filter((item) => item.id !== id)
            );
          } else {
            throw new Error(data?.message);
          }
        } catch (error) {
          console.log(error);
          Swal.fire(
            "Lỗi!",
            error?.message || "Đã có lỗi xảy ra khi xóa lịch sử.",
            "error"
          );
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  // const handlePageChange = (event, value) => {
  //   setCurrentPage(value);
  // };

  // const handleOpenFanpageDialog = (item) => {
  //   setFanpagesSelected(item.fanpages);
  //   setGptVectorId(item.id);
  //   setIsOpen(true);
  // };

 

  // const fetchTrainingHistory = useCallback(async () => {
  //   try {
  //     setIsLoading(true);
  //     const res = await fetch(
  //       `${api.gpt_assistant_training_history}?page=${currentPage}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${is_login}`,
  //         },
  //       }
  //     );
  //     const data = await res.json();
  //     if (data?.success) {
  //       setTrainingHistoryList(data?.data);
  //       setTotalPage(data?.total_page || 1);
  //     } else {
  //       throw new Error(data?.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }, [is_login, currentPage, setIsLoading]);

  useEffect(() => {
    (async () => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${is_login}`,
        },
      };
      fetch(`${api.gpt_assistant_get_total_price}?ai_bot_id=${ai_id}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            setTotalPrice(result?.total_price || 0);
          }else {
            Swal.fire(
              result?.message || t("common.message.pleaseTryAgain"),
              "",
              "error"
            );
          }
        })
        .catch((error) => {
          Swal.fire(
            error?.message || t("common.message.pleaseTryAgain"),
            "",
            "error"
          );
        });
    })();
  }, [is_login]);

  return (
    <div
      style={{
        paddingBottom: 40,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1
          // pt: 4,
          // pb: 2,
        }}
      >
        <Box>
          
          <Typography
            variant="h6"
            sx={{
              mt: 1,
            }}
          >
            Tổng chi phí: {totalPrice.toLocaleString()} VNĐ
          </Typography>
        </Box>
        {totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
          />
        )}
      </Box>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow style={{ whiteSpace: "nowrap" }}>
              <TableCell
                sx={{
                  width: 50,
                }}
              >
                STT
              </TableCell>
              {/* <TableCell>Fanpage</TableCell> */}
              {/* <TableCell>Nhóm Page</TableCell> */}
              <TableCell sx={{ width: 450 }}>Nội dung</TableCell>
              {/* <TableCell>Model sử dụng</TableCell>
              <TableCell>Tỷ giá</TableCell> */}
              {/* <TableCell>Tổng token</TableCell> */}
              <TableCell>Tổng chi phí</TableCell>
              <TableCell>Thao tác</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : trainingHistotyList.length > 0 ? (
              trainingHistotyList.map((item, index) => {
                return (
                  <TableRow key={item.id}>
                    <TableCell>{(currentPage - 1) * 10 + index + 1}</TableCell>
                    {/* <TableCell>
                      <FanpageList
                        onSuccess={
                          (index, data) => {
                            const new_data = [...trainingHistotyList]
                            new_data[index]["fanpages"] = data
                            setTrainingHistoryList(new_data)
                          }
                        }
                        item={item}
                        listFanpages={listFanpages}
                        is_login={is_login}
                        key={index}
                        no={index}
                      />
                    </TableCell> */}
                    {/* <TableCell>
                      <FanpageGroupForVector
                        key={index}
                        item={item}
                        is_login={is_login}
                        no={index}
                        onSuccess={
                          (index, data) => {
                            const new_data = [...trainingHistotyList]
                            new_data[index]["fanpage_groups"] = data
                            setTrainingHistoryList(new_data)
                          }
                        }
                        list_group_fanpage={list_group_fanpage}
                      />
                    </TableCell> */}
                    <TableCell
                      sx={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {item.chunk_text}
                    </TableCell>
                    {/* <TableCell>{item.model_use}</TableCell>
                    <TableCell>
                      {Number(item.exchange_rate).toLocaleString()} VNĐ
                    </TableCell> */}
                    {/* <TableCell>
                      {Number(item.total_token).toLocaleString()} Token
                    </TableCell> */}
                    <TableCell>
                      {Number(item.total_price).toLocaleString()} VNĐ
                    </TableCell>
                    <TableCell>
                      <Tooltip
                        title="Xóa lịch sử huấn luyện"
                        arrow
                        placement="top"
                      >
                        <DeleteIcon
                          color="error"
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleDeleteHistory(item.id)}
                        />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {t("common.message.emptyData")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPage > 1 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
          />
        </Box>
      )}

      <DialogFanpageList
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        fanpagesSelected={fanpagesSelected}
        setFanpagesSelected={setFanpagesSelected}
        setTrainingHistoryList={setTrainingHistoryList}
        trainingHistotyList={trainingHistotyList}
        cookie={is_login}
        setIsUpdateFanpageInVectorLoading={setIsUpdateFanpageInVectorLoading}
        listFanpages={listFanpages}
        gptVectorId={gptVectorId}
        setGptVectorId={setGptVectorId}
      />
    </div>
  );
};

export default TrainingHistoryList;
